import { getCategoryPrompt } from '../../../actions/prompt/promptActions'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Fetches prompt data for a category
 * @param {Object} category - The category
 * @param {string|number} assetId - The asset ID
 * @returns {Object} - The prompt data
 */
export const fetchPrompt = async (category, assetId) => {
  if (!category || !category.id) return null

  // Check if prompt data is already in the category
  if (category.prompt) {
    return {
      imagePrompt: category.prompt.image_prompt || '',
      videoPrompt: category.prompt.video_prompt || '',
    }
  }

  try {
    const promptData = await getCategoryPrompt(category.id, assetId)

    if (promptData) {
      // Update the category with prompt data for future reference
      if (!category.prompt) {
        category.prompt = promptData
      }

      return {
        imagePrompt: promptData.image_prompt || '',
        videoPrompt: promptData.video_prompt || '',
      }
    }

    return { imagePrompt: '', videoPrompt: '' }
  } catch (error) {
    responseHandlerService.handleError('Prompt bilgileri alınırken bir hata oluştu')
    return { imagePrompt: '', videoPrompt: '', error }
  }
}
